<template>
  <div>
    <v-text-field
      :value="value.cep"
      v-model="value.cep"
      v-touch="value.cep"
      v-mask="'cep'"
      :readonly="buscouCEP"
      :disabled="disabled"
      :loading="loadingCEP"
      :error-messages="cepErrors"
      maxlength="9"
      label="CEP"
      :append-outer-icon="buscouCEP ? 'mdi mdi-cancel' : 'mdi mdi-map-search'"
      @click:append-outer="buscouCEP ? limpaCep() : buscaCep()"
      @input="emite('cep', $event)"
      hint="Preencha o CEP e clique no botão ao lado para carregar o endereço"
      persistent-hint
    ></v-text-field>
    <v-text-field
      v-model="value.endereco"
      v-touch="value.endereco"
      :error-messages="enderecoErrors"
      :counter="80"
      label="Endereço"
      :disabled="disabled || !buscouCEP || valoresCEP.endereco"
      @input="emite('endereco', $event)"
    ></v-text-field>
    <v-text-field
      v-model="value.numero"
      v-touch="value.numero"
      :error-messages="numeroErrors"
      :counter="5"
      label="Número"
      :disabled="disabled || !buscouCEP || valoresCEP.numero"
      @input="emite('numero', $event)"
    ></v-text-field>
    <v-text-field
      v-model="value.complemento"
      v-touch="value.complemento"
      :error-messages="complementoErrors"
      :counter="80"
      label="Complemento"
      :disabled="disabled || !buscouCEP || valoresCEP.complemento"
      @input="emite('complemento', $event)"
    ></v-text-field>
    <v-text-field
      v-model="value.bairro"
      v-touch="value.bairro"
      :error-messages="bairroErrors"
      :counter="40"
      label="Bairro"
      :disabled="disabled || !buscouCEP || valoresCEP.bairro"
      @input="emite('bairro', $event)"
    ></v-text-field>
    <v-text-field v-model="cidadeUF" label="Cidade" disabled></v-text-field>
  </div>
</template>

<script>
import _ from "lodash";
import { validationMixin } from "vuelidate";
import { required, maxLength, numeric } from "vuelidate/lib/validators";
import { unmaskCEP } from "../../lib/masks";
export default {
  mixins: [validationMixin],
  validations() {
    const regras = {
      value: {
        endereco: { maxLength: maxLength(80) },
        numero: { maxLength: maxLength(5), numeric },
        complemento: { maxLength: maxLength(80) },
        bairro: { maxLength: maxLength(80) },
        cep: { maxLength: maxLength(9) }
      }
    };
    if (this.obrigatorio) {
      regras.value.endereco.required = required;
      regras.value.cep.required = required;
      regras.value.bairro.required = required;
    }
    return regras;
  },
  props: {
    obrigatorio: Boolean,
    disabled: Boolean,
    value: Object
  },
  data() {
    return {
      buscouCEP: false,
      loadingCEP: false,
      valoresCEP: {
        endereco: false,
        numero: false,
        bairro: false,
        complemento: false
      }
    };
  },
  computed: {
    enderecoErrors() {
      const errors = [];
      if (!this.$v.value.endereco.$dirty) return errors;
      !this.$v.value.endereco.required &&
        this.obrigatorio &&
        errors.push("Informe o endereço");
      !this.$v.value.endereco.maxLength && errors.push("Somente 80 caracteres");
      return errors;
    },
    numeroErrors() {
      const errors = [];
      if (!this.$v.value.numero.$dirty) return errors;
      !this.$v.value.numero.maxLength && errors.push("Somente 5 caracteres");
      return errors;
    },
    complementoErrors() {
      const errors = [];
      if (!this.$v.value.complemento.$dirty) return errors;
      !this.$v.value.complemento.maxLength &&
        errors.push("Somente 80 caracteres");
      return errors;
    },
    bairroErrors() {
      const errors = [];
      if (!this.$v.value.bairro.$dirty) return errors;
      !this.$v.value.bairro.required &&
        this.obrigatorio &&
        errors.push("Informe o bairro");
      !this.$v.value.bairro.maxLength && errors.push("Somente 40 caracteres");
      return errors;
    },
    cepErrors() {
      const errors = [];
      if (!this.$v.value.cep.$dirty) return errors;
      !this.$v.value.cep.required &&
        this.obrigatorio &&
        errors.push("Informe o CEP");
      !this.$v.value.cep.maxLength && errors.push("Somente 8 caracteres");
      return errors;
    },
    cidadeUF() {
      return this.value.cidade && this.value.cidade.nome !== ""
        ? `${this.value.cidade.nome} - ${this.value.cidade.estado.sigla}`
        : "";
    }
  },
  mounted() {
    if (this.value.cidade) {
      this.buscouCEP = true;
      this.valoresCEP = {
        endereco: this.value.endereco !== "",
        bairro: this.value.bairro !== "",
        numero: false,
        complemento: false
      };
      this.emite("cidade", this.value.cidade);
    }
  },
  methods: {
    emite(campo, valor) {
      const endereco = _.clone(this.value);
      endereco[campo] = valor;
      endereco.valido = !this.$v.value.$invalid;
      this.$emit("input", endereco);
    },
    async buscaCep() {
      if (this.value.cep.length < 9) {
        return;
      }

      try {
        const dados = await this.$store.dispatch(
          "endereco/carregarCEP",
          unmaskCEP(this.value.cep)
        );
        let endereco = _.clone(this.value);
        endereco.cep = this.value.cep;
        endereco.endereco = dados.logradouro;
        endereco.bairro = dados.bairro;
        endereco.numero = "";
        endereco.complemento = dados.complemento;
        endereco.cidade = dados.cidade;
        endereco.id_cidade = dados.cidade.id;

        endereco.valido = !this.$v.value.$invalid;

        this.valoresCEP = {
          endereco: dados.logradouro !== "",
          bairro: dados.bairro !== "",
          numero: false,
          complemento: false
        };
        this.buscouCEP = true;
        this.$emit("input", endereco);
      } catch (err) {
        if (err.response && err.response.status === 404) {
          this.$store.commit("ui/setSnackbar", { text: "CEP não encontrado" });
        }
        this.limpaEndereco();
      }
    },
    limpaCep() {
      this.value.cep = "";
      this.limpaEndereco();
    },
    limpaEndereco() {
      this.buscouCEP = false;
      this.valoresCEP = {
        endereco: false,
        numero: false,
        bairro: false,
        complemento: false
      };
      const endereco = _.clone(this.value);
      endereco.endereco = "";
      endereco.bairro = "";
      endereco.complemento = "";
      endereco.id_cidade = null;
      endereco.cidade = null;
      endereco.numero = "";
      endereco.valido = !this.$v.value.$invalid;

      this.$emit("input", endereco);
    }
  }
};
</script>